// import * as MatomoNext from '@socialgouv/matomo-next'
import { event } from 'nextjs-google-analytics'

export const guideListGuardSignUp = () => {
	// if (typeof window !== 'undefined' && (window as any).gtag) {
	// 	;(window as any).gtag('event', 'guide_list_guard_signup', {
	// 		event_category: 'Engagement',
	// 	})
	// }

	event('guide_list_guard_signup', {
		category: 'Engagement',
		label: 'Guide List Guard Signup',
	})
}

export const linkClickEvent = () => {
	// google event
	// // @ts-ignore
	// gtag('event', 'guide_link_click', {
	// 	event_category: 'Engagement',
	// 	event_label: 'Guide link clicked',
	// 	value: 1,
	// })

	event('guide_link_click', {
		category: 'Engagement',
		label: 'Guide link clicked',
	})

	// matomo
	// const matomo = new MatomoTracker(6, 'https://analytics.samt.st/piwik.php')

	// // @ts-ignore
	// // _paq.push(['trackEvent', 'Engagement', 'Guide link clicked'])
	// matomo.track({
	// 	url: '/virtual/link-click',
	// 	action_name: 'Guide link clicked',
	// 	e_c: 'Engagement',
	// })

	// MatomoNext.push(['trackEvent', 'Engagement', 'Guide link clicked'])
}
